var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card',[_c('v-card-title',[_vm._v(_vm._s(_vm.$_t("attribute.basicInfo")))]),_c('MainSoftForm',{scopedSlots:_vm._u([{key:"body",fn:function(){return [_c('MyFormGenerator',{attrs:{"lg":"10","schema":_vm.schema,"validator":_vm.$v}})]},proxy:true}])})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }